(function () {
    "use strict";

    angular.module("app").controller("ReportsController", ReportsController);
    ReportsController.$inject = ["$scope", "notificationService", "habilBootbox", "webApiServices", "loadingIndicatorService", "downloadService",];
    function ReportsController($scope, notificationService, habilBootbox, webApiServices, loadingIndicatorService, downloadService) {
        const companyFilter = {
            searchTextForResults: null,
            Search: searchCompanies,
            results: []
        };

        $scope.CompanyFilter = companyFilter;
        $scope.ConfigureReport = ConfigureReport;

        function initialize() {
            loadingIndicatorService.SetLoadingState(true);

            webApiServices.GetAllReports(
                (result) => {
                    if (CheckResultReceived(result)) {
                        $scope.allReports = result.data;
                    }
                    else
                        DoShowError(notificationService, result);
                },
                (err) => DoShowError(notificationService, err),
                () => loadingIndicatorService.SetLoadingState(false)
            );
        }

        initialize();

        function searchCompanies() {
            // Wait until at least 3 characters are entered before searching
            let searchText = $scope.filters.OrganisationNumber?.replace(/[.]/g, '');

            if (!searchText || searchText.length < 3)
                return;

            if (companyFilter.results.some(c => c.KboNumber === searchText))
                return;

            webApiServices.GetOrganisationsByKboNumberOrName(
                { Keyword: searchText },
                (result) => {
                    companyFilter.searchTextForResults = searchText;

                    const foundCompanies = result.data;
                    foundCompanies.forEach(c => c.Title = `${c.Name.replace(/[.]/g, '')} - (${c.KboNumber})`);

                    companyFilter.results = foundCompanies;
                },
                (err) => DoShowError(notificationService, err)
            );
        }

        function ConfigureReport(report) {
            $scope.currentReport = report;

            $scope.filters = { IncludeOldHabilData: false };

            habilBootbox.customDialog({
                templateUrl: "Reports/Dialog",
                scope: $scope,
                title: $scope.translations.Administration_Parameters_Filter,
                size: "large",
                onEscape: true,
                buttons: {
                    ok: {
                        label: "OK",
                        className: "btn-primary",
                        callback: () => generate(report)
                    },
                    cancel: {
                        label: $scope.translations.Button_Cancel,
                        className: "btn-default"
                    }
                }
            });
        }

        function generate(report) {
            loadingIndicatorService.SetLoadingState(true);

            const filters = Object.entries($scope.filters).map(entry => ({ Field: entry[0], Value: entry[1] }));

            webApiServices.GetReportByIdAndFilter(
                { ReportType: report.Type, Filters: filters },
                downloadService.saveExport,
                (err) => DoShowError(notificationService, err),
                () => loadingIndicatorService.SetLoadingState(false)
            );
        }
    }
})();